import { QuestionBase } from './question-base.model';

export class subHeadingQuestion extends QuestionBase<string> {
    controlType = 'subHeading';
    action_name: string;
    aciton_type: string;
    action_config: any;
    showLabel: boolean;
    constructor(options: {} = {}) {
        super(options);
        this.showLabel = false;
    }
}
